module.exports = require("@wix/platform-editor-sdk/lib/editorSDK");;